import { DefaultTheme } from "styled-components";

const Theme: DefaultTheme = {
  title: "dark",

  mobile_max_width: 770,
  tablet_max_width: 980,
  max_screen_width: 1300,

  primary: "#0CB50c",

  error: "#eb4245",
  success: "#3dd67b",

  text: "#fff",
  text_light: "#9A9A9A",

  shadow: "#181818",
  border: "#3C3C3C",

  background: "#181818",
  background_mid: "#292929",
  background_light: "#424242",
};

export default Theme;
